import ClassifyDivider from '@classify/react-core-components/Divider';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ spacing }) => ({
    dividerRoot: {
      margin: spacing(1, 0),
    },
  })
);

const Divider = () => {
  const classes = useStyles();
  return <ClassifyDivider classes={{ root: classes.dividerRoot }} />;
};

export default Divider;
